<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Downloads</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <button
            type="button"
            class="btn btn-primary btn-with-addon"
            @click="handleRefresh"
          >
          <span class="btn-addon">
            <i class="btn-addon-icon fe fe-refresh-cw" />
          </span>
            Refresh
          </button>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <export-exam-table :data="data" :loading="loading" @handleUpdateExportFileTable="handleUpdateExportFileTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
            showSizeChanger
            @showSizeChange="onShowSizeChange"
            :total="meta.total"
            :pageSize.sync="pageSize"
            v-model="current"
            @change="onChange"
          >
          </a-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExportExamTable from '@/components/exam/examreportdownload'

export default {
  components: {
    ExportExamTable,
  },
  beforeMount: function() {
    /* let rc = this.$roleutility.checkpermission('class', 22)
    rc.then(data => {
      console.log(data)
      this.pagepermission = data.pagePermission
    }) */
  },
  mounted: function() {
    this.getExportFiles()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    getExportFiles: function() {
      this.loading = true
      this.$http.get('/api/export/all', {
        params: {
          limit: this.pageSize,
          page: this.current,
          category: 'ExamResult',
        },
      }).then(({ data }) => {
        console.log(data.data)
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleRefresh() {
      this.getExportFiles()
    },
    handleCreated: function() {
      this.getExportFiles()
    },
    handleUpdateExportFileTable: function() {
      this.getExportFiles()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getExportFiles()
    },
    onChange(current) {
      this.current = current
      this.getExportFiles()
    },
  },
}
</script>
<style>
.error { padding: 25px 5px; }
</style>
